import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function DisclaimerPage() {
  useEffect(() => {
    document.title = 'Disclaimer | AllChinaBuy Spreadsheet Hub';
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
          <div className="max-w-3xl mx-auto">
            <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-6">Disclaimer</h1>
            <div className="prose max-w-none text-foreground-700 leading-relaxed space-y-4">
              <p><strong>Last Updated:</strong> August 26, 2026</p>
              <p>
                The information provided on AllChinaBuy Spreadsheet Hub is for general educational and informational purposes only. By using this website, you acknowledge and agree to the following terms.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">No Affiliation</h2>
              <p>
                This website is an independent resource and is not affiliated with, endorsed by, or sponsored by any buying-agent platform, marketplace, or seller. All trademarks, brand names, and logos mentioned are the property of their respective owners.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">No Guarantees</h2>
              <p>
                We do not guarantee the accuracy, completeness, or timeliness of any information on this website. Product availability, pricing, shipping costs, and platform policies change frequently. We are not responsible for any discrepancies between the information provided and the actual services offered by third-party platforms.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">No Liability for Transactions</h2>
              <p>
                We do not process transactions, sell products, or handle payments. All purchases are made directly through third-party platforms. We are not liable for any transaction outcomes, product quality, shipping issues, or disputes between buyers and sellers or platforms.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Research Responsibility</h2>
              <p>
                All purchasing decisions are your sole responsibility. We strongly encourage you to conduct independent research, verify current information with platforms and sellers, and make informed decisions based on your own judgment.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">External Links</h2>
              <p>
                This website contains links to external websites, including our main site at kaspreadsheet.com. We are not responsible for the content, privacy practices, or terms of these external sites. Visiting external links is at your own discretion and risk.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Risk Acknowledgment</h2>
              <p>
                Using buying-agent platforms involves inherent risks, including but not limited to product quality issues, shipping delays, customs complications, payment risks, and potential fraud. By using information from this website, you acknowledge that you understand these risks and agree to make decisions at your own risk.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Changes to This Disclaimer</h2>
              <p>
                We may update this disclaimer from time to time. Changes will be posted on this page with the updated date. We encourage you to review this disclaimer periodically.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}